/*
 * Frame size picker (snippets/frame-size-variant-picker.liquid).
 * Holds one selected value per option position and resolves the variant by
 * comparing option arrays, never by building or splitting variant titles.
 * Every selection goes through apply(), which owns the variant id, URL, price,
 * buttons, measurements, gallery and lens-flow state for these products.
 */
(function () {
	'use strict';

	var MEASUREMENT_PATTERN =
		/(lens width|lens height|nose bridge|bridge width|hinge to hinge|temple size|temple length|frame width)\s*:?\s*(\d+(?:\.\d+)?)\s*mm(?:\s*(?:\|\|)?\s*\(?\s*(\d+(?:\.\d+)?)\s*inch(?:es)?\s*\)?)?/gi;
	var HEADER_KEYS = {
		lens: ['lens width'],
		bridge: ['nose bridge', 'bridge width'],
		temple: ['temple size', 'temple length'],
	};

	function init() {
		var root = document.querySelector('[data-frame-size-picker]');
		var configEl = root && root.querySelector('[data-frame-size-config]');
		if (!configEl) return;

		var config;
		try {
			config = JSON.parse(configEl.textContent);
		} catch (error) {
			return;
		}

		var variants = config.variants || [];
		var colorIndex = config.colorIndex;
		var lensIndex = config.lensIndex;
		var sizeIndex = config.sizeIndex;
		var current = findById(new URLSearchParams(window.location.search).get('variant')) || findById(config.currentId);
		if (!current) return;

		var descriptionMeasurements = null;

		function findById(id) {
			if (!id) return null;
			for (var i = 0; i < variants.length; i++) {
				if (String(variants[i].id) === String(id)) return variants[i];
			}
			return null;
		}

		function findExact(options) {
			for (var i = 0; i < variants.length; i++) {
				var match = true;
				for (var j = 0; j < options.length; j++) {
					if (variants[i].options[j] !== options[j]) {
						match = false;
						break;
					}
				}
				if (match) return variants[i];
			}
			return null;
		}

		// When the exact combination doesn't exist, keep the clicked value and as
		// many of the other selections as possible, preferring available variants.
		function findNearest(index, value, options) {
			var best = null;
			var bestScore = -1;
			variants.forEach(function (variant) {
				if (variant.options[index] !== value) return;
				var score = 0;
				variant.options.forEach(function (option, i) {
					if (i !== index && option === options[i]) score += 2;
				});
				if (variant.available) score += 1;
				if (score > bestScore) {
					best = variant;
					bestScore = score;
				}
			});
			return best;
		}

		function variantWith(index, value) {
			var options = current.options.slice();
			options[index] = value;
			return findExact(options);
		}

		function parseMeasurements(text) {
			var rows = [];
			var seen = {};
			var match;
			MEASUREMENT_PATTERN.lastIndex = 0;
			while ((match = MEASUREMENT_PATTERN.exec(text || ''))) {
				var key = match[1].toLowerCase();
				if (seen[key]) continue;
				seen[key] = true;
				rows.push({ label: match[1], key: key, mm: match[2], inches: match[3] || '' });
			}
			return rows;
		}

		function getDescriptionMeasurements() {
			if (descriptionMeasurements) return descriptionMeasurements;
			var text = '';
			try {
				var productData = JSON.parse(document.getElementById('product-data').textContent);
				var doc = new DOMParser().parseFromString(productData.description || '', 'text/html');
				text = doc.body.textContent || '';
			} catch (error) {
				text = '';
			}
			descriptionMeasurements = parseMeasurements(text);
			return descriptionMeasurements;
		}

		function getMeasurements(variant) {
			var fromVariant = parseMeasurements((variant.measurements || []).join('\n'));
			return fromVariant.length ? fromVariant : getDescriptionMeasurements();
		}

		function headerValue(rows, keys) {
			for (var i = 0; i < rows.length; i++) {
				if (keys.indexOf(rows[i].key) !== -1) return rows[i].mm;
			}
			return '';
		}

		function sizeText(variant, rows) {
			var label = variant.options[sizeIndex] + ' fit';
			var lens = headerValue(rows, HEADER_KEYS.lens);
			var bridge = headerValue(rows, HEADER_KEYS.bridge);
			var temple = headerValue(rows, HEADER_KEYS.temple);
			if (lens && bridge && temple) label += ' (' + lens + '-' + bridge + '-' + temple + 'mm)';
			return label;
		}

		function updateMeasurements(variant) {
			var rows = getMeasurements(variant);
			var text = sizeText(variant, rows);

			root.querySelectorAll('[data-frame-size-value]').forEach(function (el) {
				el.textContent = text;
			});

			document.querySelectorAll('[data-frame-size-measurements]').forEach(function (box) {
				box.textContent = '';
				if (!rows.length) {
					box.hidden = true;
					return;
				}

				var title = document.createElement('p');
				title.className = 'frame-size-measurements__title';
				var fit = document.createElement('span');
				fit.textContent = variant.options[sizeIndex] + ' fit';
				title.append('Your frame: ', fit);
				box.appendChild(title);

				var list = document.createElement('dl');
				list.className = 'frame-size-measurements__list';
				rows.forEach(function (row) {
					var item = document.createElement('div');
					item.className = 'frame-size-measurements__row';
					var term = document.createElement('dt');
					term.textContent = row.label;
					var value = document.createElement('dd');
					value.textContent = row.mm + 'mm';
					if (row.inches) {
						var inches = document.createElement('span');
						inches.textContent = row.inches + ' in';
						value.appendChild(inches);
					}
					item.appendChild(term);
					item.appendChild(value);
					list.appendChild(item);
				});
				box.appendChild(list);
				box.hidden = false;
			});
		}

		function displayLabel(variant) {
			var label = variant.options[colorIndex];
			if (lensIndex >= 0) label += ' / ' + variant.options[lensIndex];
			return label;
		}

		function updateSwatches(variant) {
			root.querySelectorAll('[data-option-index]').forEach(function (el) {
				var index = Number(el.getAttribute('data-option-index'));
				var value = el.getAttribute('data-option-value');
				var active = variant.options[index] === value;
				var target = active ? variant : variantWith(index, value);
				var landing = target || findNearest(index, value, variant.options);

				el.classList.toggle('is-active', active);
				el.setAttribute('aria-checked', active ? 'true' : 'false');
				el.setAttribute('data-variant-available', landing && landing.available ? 'true' : 'false');

				// Sizes the selected color isn't made in are hidden rather than
				// letting a click switch the color. Sold-out sizes stay visible.
				if (index === sizeIndex) el.hidden = !target;

				// Color swatches stand in for the variant for the legacy readers
				// (lens-flow sync on open, page-load gallery and Rx link setup).
				target = landing;
				if (index === colorIndex && target) {
					el.setAttribute('data-variant-id', target.id);
					el.setAttribute('data-variant-title', displayLabel(target));
					el.setAttribute('data-variant-price', String(target.price / 100));
					el.setAttribute('data-prescription-btn', target.rxButton || '');
				}
			});

			var activeColor = root.querySelector('.frame-size-picker__colors .is-active');
			var seasonal = !!(activeColor && activeColor.closest('.frame-size-picker__colors--seasonal'));
			var colorLabel = document.getElementById('selected-color');
			var seasonalLabel = document.getElementById('selected-seasonal-color');
			if (colorLabel) colorLabel.textContent = seasonal ? '' : variant.options[colorIndex];
			if (seasonalLabel) seasonalLabel.textContent = seasonal ? variant.options[colorIndex] : '';

			var lensLabel = document.getElementById('selected-lens-color');
			if (lensLabel && lensIndex >= 0) lensLabel.textContent = variant.options[lensIndex];

			if (typeof window.syncVariantThumbnailRadioState === 'function') {
				window.syncVariantThumbnailRadioState(root);
			}
		}

		function updateVariantInputs(variant) {
			var inputs = document.querySelectorAll(
				'.product [name="id"], .fly-add-to-cart [name="id"], .product .product-variant-id',
			);
			inputs.forEach(function (input) {
				input.value = variant.id;
			});
			if (inputs[0]) inputs[0].dispatchEvent(new Event('change', { bubbles: true }));

			var url = new URL(window.location.href);
			if (url.searchParams.get('variant') !== String(variant.id)) {
				url.searchParams.set('variant', variant.id);
				window.history.replaceState(window.history.state, '', url.toString());
			}

			if (typeof window.updateDescriptionGlobal === 'function') window.updateDescriptionGlobal();
		}

		function updatePrice(variant) {
			var priceBox = document.querySelector('.product__main-info-wrapper .price.price--large');
			if (priceBox) {
				var regularPrice = priceBox.querySelector('.price__regular .price-item');
				var comparePrice = priceBox.querySelector('s.price-item.price-item--regular');
				var salePrice = priceBox.querySelector('.price__sale .price-item--last, .price__sale .price-item--sale');

				if (variant.compareFormatted) {
					priceBox.classList.add('price--on-sale');
					if (comparePrice) comparePrice.textContent = variant.compareFormatted;
					if (salePrice) salePrice.textContent = variant.priceFormatted;
				} else {
					priceBox.classList.remove('price--on-sale');
					if (regularPrice) regularPrice.textContent = variant.priceFormatted;
					if (salePrice) salePrice.textContent = variant.priceFormatted;
					if (comparePrice) comparePrice.textContent = variant.priceFormatted;
				}
			}

			document.querySelectorAll('.custom_add').forEach(function (el) {
				el.textContent = 'Add - ' + variant.priceFormatted;
			});
		}

		function toggle(selector, hidden) {
			document.querySelectorAll(selector).forEach(function (el) {
				el.classList.toggle('hide', hidden);
			});
		}

		function updateButtons(variant) {
			var available = !!variant.available;

			if (config.isRx) {
				toggle('.product .button_box .select-lenses', !available);
				toggle('.product .button_box .general-buy-btns', available);
				toggle('.product .custom_button.add_to_cart', true);
				toggle('.product .custom_button.sold_out', available);
			} else {
				toggle('.product .custom_button.add_to_cart, .fly-add-to-cart .custom_button.add_to_cart', !available);
				toggle('.product .custom_button.sold_out, .fly-add-to-cart .custom_button.sold_out', available);
			}

			if (!available) {
				document.querySelectorAll('.custom_button.sold_out > span').forEach(function (span) {
					span.style.display = 'unset';
					span.classList.remove('hide');
				});
			}
		}

		function mediaPrefix(alt) {
			return String(alt || '')
				.replace(/\\/g, '')
				.split('||')[0]
				.trim();
		}

		function updateGallery(variant, resetPosition) {
			var items = Array.prototype.slice.call(
				document.querySelectorAll('.product media-gallery .product__media-list .product__media-item'),
			);
			var shown = 0;

			items.forEach(function (item) {
				var alt = item.getAttribute('data-variant-media-alt');
				if (alt === 'E-GIFT CARD') return;
				var match = mediaPrefix(alt) === variant.title;
				item.style.display = match ? 'block' : 'none';
				if (match) shown++;
			});

			if (!shown && variant.featuredMediaId) {
				items.forEach(function (item) {
					var mediaId = item.getAttribute('data-media-id') || '';
					if (mediaId.split('-').pop() === String(variant.featuredMediaId)) {
						item.style.display = 'block';
						shown++;
					}
				});
			}

			document.querySelectorAll('.product-media-modal__content .modal-image-wrapper').forEach(function (wrapper) {
				var img = wrapper.querySelector('img');
				var alt = wrapper.getAttribute('data-variant-media-alt') || (img && img.getAttribute('alt'));
				wrapper.style.display = mediaPrefix(alt) === variant.title ? 'block' : 'none';
			});

			document.querySelectorAll('.slider-circle-button').forEach(function (dot, index) {
				dot.style.display = index < shown ? 'block' : 'none';
			});

			if (resetPosition) {
				var slider = document.querySelector('.product slider-component');
				if (slider && typeof slider.setSlidePosition === 'function') slider.setSlidePosition(0);
				var desktopMedia = document.querySelector('.product-section__desktop-media');
				if (window.innerWidth < 768 && desktopMedia) desktopMedia.scrollTo(0, 0);
			}
		}

		function updateVariantBlocks(variant) {
			var id = String(variant.id);

			document.querySelectorAll('.variant-badges[data-badges-variant]').forEach(function (badge) {
				badge.classList.toggle('hidden-badge', badge.getAttribute('data-badges-variant') !== id);
			});
			document.querySelectorAll('.polarized-badge[data-polarized-variant]').forEach(function (badge) {
				badge.classList.toggle('hidden-badge', badge.getAttribute('data-polarized-variant') !== id);
			});

			document.querySelectorAll('.product-description__section[data-variant-id]').forEach(function (section) {
				section.classList.toggle('hide', section.getAttribute('data-variant-id') !== id);
			});
			document.querySelectorAll('.product-section__included-products[data-variant-id]').forEach(function (block) {
				block.classList.toggle('hide', block.getAttribute('data-variant-id') !== id);
			});

			var productInfo = document.querySelector('product-info');
			var features = productInfo && productInfo.querySelector('.accordion__content.features');
			var template = productInfo && productInfo.querySelector('[data-variant-features-template][data-variant-id="' + id + '"]');
			if (features && template) features.innerHTML = template.innerHTML;
		}

		function updateRxLink(variant) {
			var links = document.querySelector('.prescription-links');
			var link = links && links.querySelector('.link-to-rx');
			var hasLink = !!variant.rxButton;

			if (links) links.style.display = hasLink ? 'block' : 'none';
			if (link) {
				link.classList.toggle('link-to-rx_visible', hasLink);
				link.setAttribute('href', variant.rxButton || '');
			}

			var image = document.querySelector('.link-to-rx .rx-image');
			if (image && variant.rxImage) image.setAttribute('src', variant.rxImage);
		}

		function updateFlow(variant) {
			var flowRoot = document.getElementById('wmp-prescription-flow');
			if (!flowRoot) return;

			var label = displayLabel(variant);
			flowRoot.setAttribute('data-product-variant', label);
			flowRoot.setAttribute('data-product-variant-id', String(variant.id));
			flowRoot.setAttribute('data-product-price', String(variant.price));

			var sidebarVariant = flowRoot.querySelector('.wmp-flow__product-variant');
			if (sidebarVariant) sidebarVariant.textContent = label;
			var mobileVariant = flowRoot.querySelector('.wmp-flow__mobile-product-variant');
			if (mobileVariant) mobileVariant.textContent = label;

			var visibleImage = document.querySelector(
				'.product media-gallery .product__media-item:not([style*="display: none"]) img',
			);
			var imageSrc = visibleImage ? visibleImage.currentSrc || visibleImage.getAttribute('src') || '' : '';
			if (imageSrc) {
				flowRoot.setAttribute('data-product-image', imageSrc);
				var flowImage = flowRoot.querySelector('.wmp-flow__product-image img');
				if (flowImage) flowImage.setAttribute('src', imageSrc);
				var mobileThumb = flowRoot.querySelector('.wmp-flow__mobile-thumb');
				if (mobileThumb) mobileThumb.setAttribute('src', imageSrc);
			}

			var store = window.WmpStore;
			if (store && typeof store.get === 'function' && typeof store.set === 'function') {
				var product = store.get('product') || {};
				product.variant = label;
				product.variantId = variant.id;
				product.price = variant.price;
				if (imageSrc) product.image = imageSrc;
				store.set('product', product);

				var pricing = store.get('pricing') || {};
				pricing.frame = variant.price;
				store.set('pricing', pricing);
			}
		}

		function apply(variant, isInitial) {
			current = variant;
			updateSwatches(variant);
			updateVariantInputs(variant);
			updatePrice(variant);
			updateButtons(variant);
			updateMeasurements(variant);
			updateGallery(variant, !isInitial);
			updateVariantBlocks(variant);
			updateRxLink(variant);
			updateFlow(variant);
		}

		function select(index, value) {
			// A re-click changes nothing here, but the legacy swatch handlers have
			// already rewritten the Rx link from the clicked element
			if (current.options[index] === value) {
				updateRxLink(current);
				return;
			}
			var options = current.options.slice();
			options[index] = value;
			var variant = findExact(options) || findNearest(index, value, options);
			if (variant) apply(variant, false);
		}

		root.addEventListener('click', function (event) {
			var option = event.target.closest('[data-option-index]');
			if (!option || !root.contains(option)) return;
			select(Number(option.getAttribute('data-option-index')), option.getAttribute('data-option-value'));
		});

		apply(current, true);
	}

	// Run after every DOMContentLoaded handler in product-section.js, which
	// filters the gallery and Rx link from the active swatch on load.
	if (document.readyState === 'complete') {
		init();
	} else {
		document.addEventListener('DOMContentLoaded', function () {
			setTimeout(init, 0);
		});
	}
})();
